/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Behaviour } from "core/models/lifestyle-declared-journal-event";
import ForcJournalEventBaseComponent from "core/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "core/components/forc/utils/journal-event-retrieval-strategies";
import LifestyleDeclaredJournalEvent from "core/models/lifestyle-declared-journal-event";
export default class LifestylCoachingEditionComponent extends ForcJournalEventBaseComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "journalEventProperties", ["behaviours"]);
    _defineProperty(this, "retrieveJournalEvent", JournalEventRetrievalStrategies.sourceOrLastJournalEvent);
    _defineProperty(this, "availableKeys", ["sleep", "physicalActivity", "food", "drugs", "stress"]);
    _defineProperty(this, "commentaryPrefix", "commentary-");
  }
  retrieveModel() {
    const model = super.retrieveModel();

    // If there is a previous JE comming from our JournalEventRetrievalStrategies
    // the model should have a behaviours property
    if (model.behaviours) {
      // Inject the content of the array directly in our model
      model.behaviours.forEach(behavior => {
        model[behavior.key] = true;
        model[this.getCommentKey(behavior.key)] = behavior.comment;
      });
    }
    return model;
  }
  computePayload() {
    const payload = super.computePayload();
    payload.occurredAt = new Date();

    // Retrieve and rebuild an array from the value in the changeset.
    payload.behaviours = this.availableKeys.map(key => {
      if (!this.model[key]) return;
      return {
        key: key,
        comment: this.model[this.getCommentKey(key)]
      };
    }).filter(behavior => behavior != null);
    return payload;
  }
  getCommentKey(key) {
    return this.commentaryPrefix + key;
  }
}
_defineProperty(LifestylCoachingEditionComponent, "fullComponentId", "lifestyle/coaching-edition-form");
_defineProperty(LifestylCoachingEditionComponent, "forcDisplayName", "Hygiène de vie");
_defineProperty(LifestylCoachingEditionComponent, "journalEventClass", LifestyleDeclaredJournalEvent);